import { TableHeader } from "@/models/TableHeader";

export const surveyIndexHeaders: TableHeader[] = [
  {
    text: "ID",
    value: "id"
  },
  {
    text: "Name",
    value: "name"
  },
  {
    text: "Slug",
    value: "slug"
  },
  {
    text: "Created At",
    value: "created_at"
  },
  {
    text: "Updated At",
    value: "updated_at"
  },
  {
    text: "Actions...",
    sortable: false
  }
];
